import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

export default function Extras({setData, form, extras}) {

    const carouselSettings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
        ]
    };

    let removedExtraPrice = false;
    let removedExtraPriceAtt = false;

    return (
        <>
            <Slider {...carouselSettings}>
                {
                    extras.filter(function (item) {
                        if (item?.id > 0 && (!form?.deal || !item?.deals.includes(form?.deal))) {
                            return false; // skip
                        }
                        return true;
                    }).map((item) => {
                        let className = form?.extra.indexOf(item.id) !== -1 ? 'extra_item_selected' : 'extra_item';
                        return (
                            <div key={'extra_' + item.id} onClick={() => {
                                let index = form?.extra.indexOf(item.id);

                                if (index === -1) {
                                    setData(
                                        {
                                            extra: [...form?.extra, item.id],
                                            extraPrice: [...form?.extraPrice, item.price],
                                            extraPriceAtt: [...form?.extraPriceAtt, item.price_attendants]
                                        }
                                    )
                                } else {
                                    let extra = form?.extra.filter(function (i) {
                                        return i !== item.id
                                    });
                                    let extraPrice = form?.extraPrice.filter(function (i) {
                                        if (i === item.price) {
                                            removedExtraPrice = true;
                                            return false;
                                        }
                                        return removedExtraPrice || i !== item.price
                                    });
                                    let extraPriceAtt = form?.extraPriceAtt.filter(function (i) {
                                        if (i === item.price_attendants) {
                                            removedExtraPriceAtt = true;
                                            return false;
                                        }
                                        return removedExtraPriceAtt || i !== item.price_attendants
                                    });

                                    setData(
                                        {
                                            extra: extra,
                                            extraPrice: extraPrice,
                                            extraPriceAtt: extraPriceAtt
                                        }
                                    )
                                }
                            }}>
                                <div className={className}
                                     style={{"backgroundImage": `url(` + item.image + `)`}}>
                                </div>
                                <div className={'title'}>
                                    {item.name}
                                </div>
                            </div>
                        );
                    })
                }
            </Slider>
        </>
    );
}

